import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import Form from '../../components/Fields/Form';
import SwitchField from '../../components/Fields/SwitchField';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import ExternalSystemModel from '../../models/ExternalSystemModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';


const MenuItemView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const [formData, setFormData] = useState<ExternalSystemModel>({ id: 0, name: '', show: true, concurrencyId: ''});

    let idParams: IdParams = useParams();
    let externalSystemId: number | undefined;
    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        externalSystemId = parseInt(idParams.id);
    }

    useEffect(() => {
        if (externalSystemId !== undefined) {
            DataService.getById<ExternalSystemModel>('api/v1/externalsystems/', externalSystemId)
                .then(response => setFormData(response))
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [externalSystemId]);

    function submit() {
        if (formData) {
            DataService
                .update<ExternalSystemModel>(`api/v1/externalsystems/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }, { type: 'isMaxLength', maxLength:100 }] },
            { name: 'exportPath', label: 'Export path' },
            { name: 'importPath', label: 'Import path' },
            { name: 'show', label: 'Show' },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    const { isAuthorizedFor } = useAuth();
    if (externalSystemId === undefined) {
        if (!isAuthorizedFor(ApplicationFunctions.EditExternalSystem)) {
            return (<Unauthorized />);
        }
    }
    else if (!isAuthorized) {
        return (<Unauthorized />);
    }

    return (
        <div className='main-content'>
            <Form title='External system' footer={(
                <Row>
                    <Col md='12'>
                        <ButtonBar offset={2}>
                            <Authorize applicationFunction={ApplicationFunctions.EditMenuItem}>
                                <SaveButton  {...getSubmitButtonProps()} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <TextboxField {...getFieldProps('name')} />
                            <TextboxField {...getFieldProps('exportPath')} />
                            <TextboxField {...getFieldProps('importPath')} />
                            <SwitchField {...getFieldProps('show')} />
                        </Col>
                    </Row>
                </Container>
            </Form>
        </div>
    );
}
export default MenuItemView;